// extracted by mini-css-extract-plugin
export default {"wrapper":"tabs_wrapper__TKJPT","tab":"tabs_tab__oBl1N","selectedTab":"tabs_selectedTab__yDrQO"};